import React from 'react';

import { CloseIcon } from '@icons';

import * as Styled from './bottom-sheet-modal.styled';

type OwnProps = {
	isOpen: boolean;
	onClose: () => void;
	title: string | React.ReactNode;
	children: React.ReactNode;
};

const BottomSheetModal: React.FC<OwnProps> = ({ isOpen, onClose, title, children }) => {
	// Close on overlay click
	const handleOverlayClick = (e: React.MouseEvent) => {
		if (e.target === e.currentTarget) {
			onClose();
		}
	};

	// Prevent body scroll when modal is open
	React.useEffect(() => {
		if (isOpen) {
			document.body.style.overflow = 'hidden';
		} else {
			document.body.style.overflow = '';
		}

		return () => {
			document.body.style.overflow = '';
		};
	}, [isOpen]);

	return (
		<Styled.Overlay $isOpen={isOpen} onClick={handleOverlayClick}>
			<Styled.Container>
				<Styled.CloseButton onClick={onClose}>
					<CloseIcon />
				</Styled.CloseButton>

				<Styled.Title>{title}</Styled.Title>

				{children}
			</Styled.Container>
		</Styled.Overlay>
	);
};

export default BottomSheetModal;

// Re-export styled components for use in parent components
export { Section, SortOptions, SortItem, FilterChips, Buttons } from './bottom-sheet-modal.styled';
